var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct(
                        "automatically-open-print-settings-on-add"
                      ),
                    },
                    model: {
                      value:
                        _vm.userConf
                          .AWSDocumentManagerAutomaticallyOpenPrintSettingsOnAdd,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userConf,
                          "AWSDocumentManagerAutomaticallyOpenPrintSettingsOnAdd",
                          $$v
                        )
                      },
                      expression:
                        "userConf.AWSDocumentManagerAutomaticallyOpenPrintSettingsOnAdd",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("automatically-show-with-print") },
                    model: {
                      value:
                        _vm.userConf
                          .AWSDocumentManagerAutomaticallyShowWithPrint,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userConf,
                          "AWSDocumentManagerAutomaticallyShowWithPrint",
                          $$v
                        )
                      },
                      expression:
                        "userConf.AWSDocumentManagerAutomaticallyShowWithPrint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("automatically-show-with-download"),
                    },
                    model: {
                      value:
                        _vm.userConf
                          .AWSDocumentManagerAutomaticallyShowWithDownload,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userConf,
                          "AWSDocumentManagerAutomaticallyShowWithDownload",
                          $$v
                        )
                      },
                      expression:
                        "userConf.AWSDocumentManagerAutomaticallyShowWithDownload",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("automatically-show-with-send") },
                    model: {
                      value:
                        _vm.userConf
                          .AWSDocumentManagerAutomaticallyShowWithSend,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userConf,
                          "AWSDocumentManagerAutomaticallyShowWithSend",
                          $$v
                        )
                      },
                      expression:
                        "userConf.AWSDocumentManagerAutomaticallyShowWithSend",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.isSaving, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }